module.exports = __webpack_public_path__ + "static/look-i-made-a-hat-9d441f675993d8e803b44a4e84549d4b.jpg";